/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `skin_temp_overnight` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class SkinTempOvernightMesg : Mesg {
    public constructor() : super("SkinTempOvernight", Profile.MesgNum.SKIN_TEMP_OVERNIGHT)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** timestamp. */
    public var timestamp: Instant?
        get() = (getFieldValue(TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** local_timestamp. */
    public var localTimestamp: Instant?
        get() = (getFieldValue(LOCAL_TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(LOCAL_TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** average_deviation. The average overnight deviation from baseline temperature in degrees C */
    public var averageDeviation: Float?
        get() = getFieldValue(AVERAGE_DEVIATION_FIELD_NUM) as? Float
        set(value) = setFieldValue(AVERAGE_DEVIATION_FIELD_NUM, value)

    /** average_7_day_deviation. The average 7 day overnight deviation from baseline temperature in degrees C */
    public var average7DayDeviation: Float?
        get() = getFieldValue(AVERAGE_7_DAY_DEVIATION_FIELD_NUM) as? Float
        set(value) = setFieldValue(AVERAGE_7_DAY_DEVIATION_FIELD_NUM, value)

    /** nightly_value. Final overnight temperature value */
    public var nightlyValue: Float?
        get() = getFieldValue(NIGHTLY_VALUE_FIELD_NUM) as? Float
        set(value) = setFieldValue(NIGHTLY_VALUE_FIELD_NUM, value)

    public companion object {
        public const val TIMESTAMP_FIELD_NUM: UByte = 253u
        public const val LOCAL_TIMESTAMP_FIELD_NUM: UByte = 0u
        public const val AVERAGE_DEVIATION_FIELD_NUM: UByte = 1u
        public const val AVERAGE_7_DAY_DEVIATION_FIELD_NUM: UByte = 2u
        public const val NIGHTLY_VALUE_FIELD_NUM: UByte = 4u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[253] = Field("Timestamp", 253u, BaseType.UINT32, 1.0, 0.0, "", false)
            fields[0] = Field("LocalTimestamp", 0u, BaseType.UINT32, 1.0, 0.0, "", false)
            fields[1] = Field("AverageDeviation", 1u, BaseType.FLOAT32, 1.0, 0.0, "", false)
            fields[2] = Field("Average7DayDeviation", 2u, BaseType.FLOAT32, 1.0, 0.0, "", false)
            fields[4] = Field("NightlyValue", 4u, BaseType.FLOAT32, 1.0, 0.0, "", false)
            return fields
        }
    }
}
